import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTag, faTimes } from '@fortawesome/free-solid-svg-icons'
import { AppliedDiscount } from '../../types/coupon'
import { makeNumbersFarsi } from '../../utils/farsi'
import { addThousandsSeparator } from '../../utils/format'

interface DiscountBreakdownProps {
  appliedDiscounts: AppliedDiscount[]
  totalDiscountAmount: number
  currency?: string
  onRemoveCoupon?: (code: string) => void
  allowRemoval?: boolean
}

export const DiscountBreakdown = ({
  appliedDiscounts,
  totalDiscountAmount,
  currency = 'IRR',
  onRemoveCoupon,
  allowRemoval = false,
}: DiscountBreakdownProps) => {
  if (!appliedDiscounts || appliedDiscounts.length === 0) {
    return null
  }

  const formatPrice = (value: number) => {
    const priceStr = value.toString().substring(0, value.toString().length - 1)
    return makeNumbersFarsi(addThousandsSeparator(priceStr))
  }

  return (
    <div className='my-4'>
      <div className='flex items-center mb-3'>
        <FontAwesomeIcon
          icon={faTag}
          className='ml-2'
          style={{ color: '#10b981' }}
        />
        <h4 className='text-md font-semibold' style={{ color: '#10b981' }}>
          تخفیف‌های اعمال شده
        </h4>
      </div>

      <div className='space-y-2'>
        {appliedDiscounts.map((discount, index) => (
          <div
            key={discount.couponId || index}
            className='flex items-center justify-between p-3 rounded bg-green-50 dark:bg-green-900/20'
          >
            <div className='flex items-center flex-1'>
              <div className='flex flex-col'>
                <div className='flex items-center'>
                  {discount.code ? (
                    <>
                      <span className='font-semibold ml-2'>
                        کد: {discount.code}
                      </span>
                      <span
                        className='text-xs px-2 py-1 rounded'
                        style={{
                          backgroundColor: 'var(--accent-secondary)',
                          color: 'white',
                        }}
                      >
                        {discount.type === 'percentage'
                          ? `${makeNumbersFarsi(discount.value)}٪`
                          : `${formatPrice(discount.value)} تومان`}
                      </span>
                    </>
                  ) : (
                    <span className='font-semibold ml-2'>
                      تخفیف خودکار
                      {discount.type === 'percentage'
                        ? ` (${makeNumbersFarsi(discount.value)}٪)`
                        : ` (${formatPrice(discount.value)} تومان)`}
                    </span>
                  )}
                </div>
                <span
                  className='text-sm mt-1'
                  style={{ color: 'var(--text-secondary)' }}
                >
                  مبلغ تخفیف: {formatPrice(discount.discountAmount)} تومان
                </span>
              </div>
            </div>

            {allowRemoval && discount.code && onRemoveCoupon && (
              <button
                onClick={() => onRemoveCoupon(discount.code!)}
                className='mr-2 p-2 hover:bg-red-100 dark:hover:bg-red-900/30 rounded transition-colors'
                title='حذف کد تخفیف'
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{ color: '#ef4444' }}
                />
              </button>
            )}
          </div>
        ))}
      </div>

      {totalDiscountAmount > 0 && (
        <div
          className='mt-4 p-3 rounded font-bold text-lg flex items-center justify-between'
          style={{
            backgroundColor: '#d1fae5',
            color: '#065f46',
          }}
        >
          <span>مجموع تخفیف:</span>
          <span>{formatPrice(totalDiscountAmount)} تومان</span>
        </div>
      )}
    </div>
  )
}

